module.exports = __webpack_public_path__ + "static/media/gc_desktop_icon.fe9bb4ee.jpeg";